module.exports = __webpack_public_path__ + "img/github.39a4096b.png";